
import { Route } from '@/app/router'

const Vehicles = () => import('./index.vue')

const VehiclesProps = ['page', 'perPage']

export default [
	new Route('/vehicles/:manufacturerId?/:modelId?', Vehicles)
		.as('Dashboard:Vehicles')
		.permissions(['VIEW_VEHICLES'])
		.props(VehiclesProps)
]
